import { render, staticRenderFns } from "./SameProduct.vue?vue&type=template&id=2c387ae4&scoped=true&"
import script from "./SameProduct.vue?vue&type=script&lang=js&"
export * from "./SameProduct.vue?vue&type=script&lang=js&"
import style0 from "./SameProduct.vue?vue&type=style&index=0&id=2c387ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c387ae4",
  null
  
)

export default component.exports